<template>
    <b-modal size="xl" v-model="showForm" :title="$t('contract')" no-close-on-backdrop no-enforce-focus>
      <template>
        <div class="row">
          <div class="col-lg-6 mb-3">
            <div class="row">
              <div v-if="formModel.type === 'enterprise' && ['image/jpeg', 'image/jpg'].includes(formModel.businessRegistrationType)" class="col-6 pb-4">
                <b-card
                    :sub-title="$t('businessRegistration')"
                    :img-src="formModel.businessRegistrationUrl || '/img/default-avatar.png'"
                    body-class="pb-1"
                    img-bottom
                    tag="a"
                    :href="formModel.businessRegistrationUrl"
                    target="_blank"
                >
                </b-card>
              </div>
              <div class="col-6 pb-4">
                <b-card
                    :sub-title="$t('ownerPicture')"
                    :img-src="formModel.ownerUrl || '/img/default-avatar.png'"
                    body-class="pb-1"
                    img-bottom
                    tag="a"
                    :href="formModel.ownerUrl"
                    target="_blank"
                >
                </b-card>
              </div>
              <div class="col-6 pb-4">
                <b-card
                    :sub-title="$t('IDFront')"
                    :img-src="formModel.IDFrontUrl || '/img/default-avatar.png'"
                    body-class="pb-1"
                    img-bottom
                    tag="a"
                    :href="formModel.IDFrontUrl"
                    target="_blank"
                >
                </b-card>
              </div>
              <div class="col-6 pb-4">
                <b-card
                    :sub-title="$t('IDBack')"
                    :img-src="formModel.IDBackUrl || '/img/default-avatar.png'"
                    body-class="pb-1"
                    img-bottom
                    tag="a"
                    :href="formModel.IDBackUrl"
                    target="_blank"
                >
                </b-card>
              </div>
              <div v-if="formModel.type === 'personal'" class="col-6 pb-4">
                <b-card
                    :sub-title="$t('proofOfAddress')"
                    :img-src="formModel.proofOfAddressUrl || '/img/default-avatar.png'"
                    body-class="pb-1"
                    img-bottom
                    tag="a"
                    :href="formModel.proofOfAddressUrl"
                    target="_blank"
                >
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="formModel.businessRegistration && !['image/jpeg', 'image/jpg'].includes(formModel.businessRegistrationType)" class="col-6 pb-4">
                <b-card
                    :sub-title="$t('businessRegistration')"
                    sub-title-text-variant="info"
                    body-class="pb-1"
                    tag="a"
                    :href="formModel.businessRegistrationUrl"
                    target="_blank"
                >
                </b-card>
              </div>

              <div v-if="formModel.contract && formModel.sendContractTime" class="col-6 pb-4">
                <b-card
                    :sub-title="$t('contract')"
                    sub-title-text-variant="info"
                    body-class="pb-1"
                    img-width="auto"
                    tag="a"
                    :href="formModel.contractUrl"
                    target="_blank"
                >
                </b-card>
              </div>
            </div>
            <hr class="mt-0 mb-3">
            <div class="row">
              <div class="col-12">
              </div>
            </div>
          </div>
          <div class="col-lg-6 px-4">
            <h5 class="text-center">{{$t('kycInformation')}}</h5>
            <div class="mb-1"><b>{{ $t('customer') }}: </b>{{ $t(formModel.type) }}</div>
            <template v-if="formModel.client">
              <div class="mb-1"><b>{{ $t('companyName') }}: </b>{{ $t(formModel.client.companyName) }}</div>
              <div class="mb-1"><b>{{ $t('domain') }}: </b>{{ $t(formModel.client.domain) }}</div>
            </template>
            <div class="mb-1"><b>{{ $t('createTime') }}: </b>{{ formModel.createTime | moment('DD/MM/YY HH:mm:ss') }}</div>
            <div v-if="formModel.createdBy" class="mb-1">
              <b>{{ $t('createdBy') }}: </b>{{ formModel.createdBy.name}} ({{ formModel.createdBy.email }})
            </div>
            <hr class="my-2">
            <h5 class="text-center">{{$t('invoiceInformation')}}</h5>
            <template v-if="formModel.type === 'enterprise'">
              <div class="mb-1"><b>{{ $t('companyName') }}: </b>{{ formModel.companyName ? formModel.companyName : $t('unknown') }}</div>
              <div class="mb-1"><b>{{ $t('address') }}: </b>{{ formModel.companyAddress ? formModel.companyAddress : $t('unknown') }}</div>
              <div class="mb-1"><b>{{ $t('taxCode') }}: </b>{{ formModel.companyTaxCode ? formModel.companyTaxCode : $t('unknown') }}</div>
            </template>
            <h6 class="text-center" v-if="formModel.type === 'enterprise'">{{$t('ownerInfo')}}</h6>
            <div class="mb-1"><b>{{ $t('fullName') }}: </b>{{ formModel.name ? formModel.name : $t('unknown') }}</div>
            <div class="mb-1"><b>{{ $t('address') }}: </b>{{ formModel.address ? formModel.address : $t('unknown') }}</div>
            <div class="mb-1"><b>{{ $t('taxCode') }}: </b>{{ formModel.taxCode ? formModel.taxCode : $t('unknown') }}</div>
            <div class="mb-1" v-if="formModel.type === 'enterprise'"><b>{{ $t('invoiceEmails') }}: </b>{{ formModel.invoiceEmails && formModel.invoiceEmails.length ? formModel.invoiceEmails.join(', ') : $t('unknown') }}</div>
            <hr class="my-2"/>
            <div class="mb-1" v-if="formModel.confirmTime">
              <b>{{ $t('confirmTime') }}: </b>{{ formModel.confirmTime | moment('DD/MM/YY HH:mm:ss') }}
            </div>
            <div class="mb-1" v-if="formModel.confirmTime && formModel.confirmedBy">
              <b>{{$t('confirmedBy')}}: </b>{{ formModel.confirmedBy.name }} ({{ formModel.confirmedBy.email }})
            </div>
            <div class="mb-1" v-if="formModel.cancelTime">
              <b>{{ $t('cancelTime') }}: </b>{{ formModel.cancelTime | moment('DD/MM/YY HH:mm:ss') }}
            </div>
            <div class="mb-1" v-if="formModel.cancelTime && formModel.canceledBy">
              <b>{{$t('canceledBy')}}: </b>{{ formModel.canceledBy.name }} ({{ formModel.canceledBy.email }})
            </div>
            <div class="mb-1" v-if="formModel.sendContractTime">
              <b>{{ $t('sendContractTime') }}: </b>{{ formModel.sendContractTime | moment('DD/MM/YY HH:mm:ss') }}
            </div>
            <div class="mb-1" v-if="formModel.sendContractTime && formModel.sentContractBy">
              <b>{{$t('sentContractBy')}}: </b>{{ formModel.sentContractBy.name }} ({{ formModel.sentContractBy.email }})
            </div>
            <div v-if="!formModel.sendContractTime" class="mb-1">
              <div class="mb-1"><b>{{ $t('contract') }}:</b></div>
              <form-file service="/upload/upload-kyc" :model="formModel" attribute="contract" :errors="formErrors"
                         :accept="'image/jpeg,image/jpg,application/pdf'">
              </form-file>
            </div>
            <div>
              <p class="mb-1"><b>{{ $t('note') }}:</b></p>
              <form-textarea row="4" attribute="note" :model="formModel" :errors="formErrors" :placeholder="$t('notePlaceholder')" />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">
          {{ $t('cancel') }}
        </button>
        <button v-if="!['accountant'].includes($store.state.user.role)" class="btn btn-primary float-right" @click="process('send-contract')">
          {{ !formModel.confirmTime ? $t('confirmAndSendContract') : $t('sendContract') }}
        </button>
      </template>
    </b-modal>
</template>

<script>
import CRUD from "../../../mixins/CRUD";

export default {
  mixins: [CRUD],
  data: function () {
    return {
      service: '/client-kyc',
      reloadBus: 'reloadKYC',
      showForm: false,
    }
  },
  methods: {
    open(item) {
      this.formModel = item;
      this.showForm = true;
    },
    process(action) {
      this.$swal({
        title: this.$t('processConfirm'),
        icon: "question",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          let url = `${this.service}/${action}/${this.formModel._id}`;
          this.$service.put(url, this.formModel).then(response => {
            if (response && response.data) {
              this.$swal({
                title: this.$t('success'),
                text: this.$t('updateSuccess'),
                icon: 'success',
                toast: true,
                timer: 5000,
                position: 'top-end'
              });
              this.showForm = false;
              if (this.reloadBus) {
                this.$bus.$emit(this.reloadBus);
              }
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            } else {
              this.formErrors = error.response.data
            }
          }).finally(() => {
            loader.hide();
          });
        }
      })
    },
  },
  i18n: {
    messages: {
      en: {
        confirmTime: 'Confirm time',
        updateSuccess: 'Update success',
        note: 'Note',
        notePlaceholder: 'Note or cancel reason',
        businessRegistration: "Business Registration",
        contract: "Contract",
        IDFront: "ID Front",
        IDBack: "ID Back",
        ownerPicture: "Owner Picture",
        createdBy: "Created by",
        customer: "Customer",
        personal: "Personal",
        enterprise: "Enterprise",
        confirmedBy: "Confirmed by",
        confirm: "Confirm",
        proofOfAddress: "Proof of address",
        cancel: "Cancel",
        confirmAndSendContract: "Confirm and send contract",
        cancelTime: "Cancel time",
        canceledBy: "Canceled by",
        sendContractTime: "Send contract time",
        profile: "Profile",
        sendContract: "Send contract",
        sentContractBy: "Sent contract by",
        processConfirm: "Do you want to perform this action?",
        invoiceInformation: "invoice information",
        address: "Address",
        taxCode: "Tax code",
        invoiceEmails: "Email receipt invoice",
        kycInformation: "KYC information",
        fullName: "Full name",
        ownerInfo: "Owner info"
      },
      vi: {
        title: "Hồ sơ khách hàng",
        confirmTime: 'Xác nhận lúc',
        updateSuccess: 'Cập nhật thành công!',
        note: 'Ghi chú của người duyệt',
        notePlaceholder: 'Ghi chú hoặc lý do từ chối',
        businessRegistration: "Đăng ký kinh doanh",
        contract: "Hợp đồng",
        IDFront: "CCCD mặt trước",
        IDBack: "CCCD mặt sau",
        ownerPicture: "Ảnh người đại diện",
        createdBy: "Tạo bởi",
        customer: "Khách hàng",
        personal: "Cá nhân",
        enterprise: "Doanh nghiệp",
        confirmedBy: "Người xác nhận",
        confirm: "Xác nhận",
        proofOfAddress: "Xác minh địa chỉ",
        cancel: "Huỷ",
        confirmAndSendContract: "Xác nhận và gửi hợp đồng",
        cancelTime: "Từ chối lúc",
        canceledBy: "Người từ chối",
        sendContractTime: "Gửi hợp đồng lúc",
        profile: "Hồ sơ",
        sendContract: "Gửi hợp đồng",
        sentContractBy: "Người gửi hợp đồng",
        processConfirm: "Bạn có chắc chắn muốn thực hiện hành động này?",
        invoiceInformation: "Thông tin xuất hoá đơn",
        address: "Địa chỉ",
        taxCode: "Mã số thuế",
        invoiceEmails: "Email nhận hoá đơn",
        kycInformation: "Thông tin KYC",
        fullName: "Họ và tên",
        ownerInfo: "Thông tin người đại diện"
      }
    }
  }
}
</script>